<template>
    <div v-if="isLoading || vehicles.length > 0" class="extended-vehicle-list">
        <div class="extended-vehicle-list__heading-wrapper">
            <svg-icon name="distance" class="extended-vehicle-list__heading-icon" />
            <h3 class="extended-vehicle-list__heading-heading">
                {{ $t('pages.vehicles.extended_results_heading') }}
            </h3>
        </div>
        <p>
            {{ $t('pages.vehicles.extended_results_description') }}
        </p>
        <VehicleList v-if="isLoading" class="vehicles__loading" :loading-count="24" />
        <VehicleList
            v-else
            :vehicles="vehicles"
            :preload="preload"
            :show-matched-dates="showMatchedDates"
            :list-name="listName"
        />
    </div>
</template>

<script>
import VehicleList from './VehicleList.vue';

export default {
    components: {
        VehicleList,
    },
    props: {
        vehicles: {
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        showMatchedDates: {
            type: Boolean,
            default: false,
        },
        listName: {
            type: String,
            default: '',
        },
        preload: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/_variables.scss';

.extended-vehicle-list {
    text-align: center;

    &__heading-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        position: relative;

        &::before,
        &::after {
            content: '';
            height: 1px;
            background-color: $border-color;
            flex: 1;
            margin: 20px;
        }
    }

    &__heading-icon {
        width: 24px;
        height: 24px;
    }

    &__heading-heading {
        @extend %heading-3;
    }
}
</style>
